<section>
  <app-style-guide-nav></app-style-guide-nav>

  <div class="w-50">
    <h3>Input validation</h3>

    <mat-form-field class="w-100">
      <mat-label>Email</mat-label>
      <input
        type="email"
        matInput
        [formControl]="emailFormControl" />
      <mat-error *ngIf="emailFormControl.hasError('email') && !emailFormControl.hasError('required')">
        Please enter a valid email address
      </mat-error>
      <mat-error *ngIf="emailFormControl.hasError('required')"> Email is <strong>required</strong> </mat-error>
    </mat-form-field>

    <h3>Textarea</h3>

    <mat-form-field class="w-100">
      <mat-label>Leave a comment</mat-label>
      <textarea matInput></textarea>
    </mat-form-field>

    <h3>Input prefix and suffix</h3>

    <mat-form-field class="w-100">
      <mat-label>Telephone</mat-label>
      <span matPrefix>+1-</span>
      <input
        type="tel"
        matInput />
      <mat-icon matSuffix>phone</mat-icon>
    </mat-form-field>

    <h3>Input hint</h3>

    <mat-form-field class="w-100">
      <mat-label>Input</mat-label>
      <input
        type="email"
        matInput />
      <mat-hint align="start"><strong>Hint on left side</strong></mat-hint>
      <mat-hint align="end"><strong>Hint on right side</strong></mat-hint>
    </mat-form-field>

    <h3>Input maxlength and remaining counter</h3>

    <mat-form-field class="w-100">
      <mat-label>Message</mat-label>
      <input
        matInput
        #message
        maxlength="20" />
      <mat-hint align="start"><strong>Don't disclose personal info</strong></mat-hint>
      <mat-hint align="end">{{ message.value.length }} / 20</mat-hint>
    </mat-form-field>

    <h3>Button to clear input</h3>

    <mat-form-field class="w-100">
      <mat-label>Clearable input</mat-label>
      <input
        matInput
        type="text"
        [(ngModel)]="textValue" />
      <button
        mat-button
        *ngIf="textValue"
        matSuffix
        mat-icon-button
        aria-label="Clear"
        (click)="textValue = ''">
        <mat-icon>close</mat-icon>
      </button>
    </mat-form-field>

    <h3>Button to mask/unmask password</h3>

    <mat-form-field class="w-100">
      <mat-label>Password</mat-label>
      <input
        matInput
        [(ngModel)]="passwordValue"
        [type]="isPasswordHidden ? 'password' : 'text'" />
      <button
        matSuffix
        mat-icon-button
        (click)="isPasswordHidden = !isPasswordHidden">
        <mat-icon>{{ isPasswordHidden ? 'visibility_off' : 'visibility' }}</mat-icon>
      </button>
    </mat-form-field>
  </div>
</section>
